import React from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import SprinklerSamplingTable from './SprinklerSamplingTable';
const queryClient = new QueryClient();
export default function SprinklerSamplingWrapper({ buildingId }) {
    return (React.createElement(QueryClientProvider, { client: queryClient },
        React.createElement(SprinklerSamplingTable, { buildingId: buildingId })));
}
